<template>
  <div>
    <h2>{{ $t('title.locations') }}</h2>

    <base-list
    model="locations"
    :columns="['name', 'contact_name']"
    sModel="location"
    />

  </div>


</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'location-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// LocationList.vue?a121fdea